import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LandTourCategory, LandTourCompulsoryCharge } from "../../../../interfaces/land-tour.interface";
import { currencyDisplay } from "../../../../utils/helpers";
import { DateSelection, PaxCounts, pricingPaxCount } from "./ChooseYourTour";
import { usePriceQuote } from "../usePriceQuote";
import { customizeTourHref } from "../customizeTourHref";
import CompulsoryChargesModal from "./CompulsoryChargesModal";

const ICONS = "/iceholidays-assets/images/icons";

const barMoney = (value: number) => {
  const formatted = currencyDisplay("MYR", value);
  return Number.isInteger(Number(value)) ? formatted.replace(/\.00$/, "") : formatted;
};

interface Props {
  landTourId: number | undefined;
  tourCode?: string;
  destination?: string;
  selectedCategory: LandTourCategory | undefined;
  selectedDate: DateSelection | undefined;
  paxCounts: PaxCounts;
  compulsoryCharges?: LandTourCompulsoryCharge[];
}

export default function GroundTourPriceBar({
  landTourId,
  tourCode,
  destination,
  selectedCategory,
  selectedDate,
  paxCounts,
  compulsoryCharges = [],
}: Props) {
  const [showCompulsory, setShowCompulsory] = useState(false);

  const { quote } = usePriceQuote({
    landTourId,
    category: selectedCategory,
    date: selectedDate?.date,
    priceDate: selectedDate?.priceDate,
    quantity: pricingPaxCount(paxCounts),
  });

  const contactHref = customizeTourHref({ tourCode, destination, departDate: selectedDate?.date });
  const hasCharges = compulsoryCharges.length > 0;

  const hasSaving = !!quote && quote.saveAmount > 0;
  const PriceBlock = hasCharges ? "button" : "div";

  return (
    <div className="ground-tour-show-v2__price-bar">
      {quote ? (
        <PriceBlock
          className="ground-tour-show-v2__price-bar-price"
          {...(hasCharges ? { type: "button" as const, onClick: () => setShowCompulsory(true), "aria-label": "View compulsory charges" } : {})}
        >
          <span className="ground-tour-show-v2__price-bar-was">
            <span className="ground-tour-show-v2__price-bar-from">
              From
              {hasSaving && (
                <span className="ground-tour-show-v2__price-bar-strike">{barMoney(quote.beforeSaveAmount)}</span>
              )}
            </span>

            {hasSaving && (
              <span className="ground-tour-show-v2__price-bar-save">Save {barMoney(quote.saveAmount)}</span>
            )}
          </span>

          <span className="ground-tour-show-v2__price-bar-now">
            <span className="ground-tour-show-v2__price-bar-amount">{barMoney(quote.price)}</span>
            <span className="ground-tour-show-v2__price-bar-suffix">/ person</span>
            {hasCharges && <img src={`${ICONS}/icon-price-bar-chevron.svg`} alt="" aria-hidden="true" />}
          </span>
        </PriceBlock>
      ) : (
        <span />
      )}

      <Link to={contactHref} className="ground-tour-show-v2__price-bar-contact">
        <img src={`${ICONS}/icon-contact-us.svg`} alt="" aria-hidden="true" />
        Contact Us
      </Link>

      {hasCharges && (
        <CompulsoryChargesModal open={showCompulsory} onClose={() => setShowCompulsory(false)} charges={compulsoryCharges} />
      )}
    </div>
  );
}
